<template>
    <div class="card pa-40 creation-civilite">
      <div class="card-content">
        <h1 class="is-size-6 has-text-weight-bold has-text-grid-1 mb-20">
          {{$t('ajoutContact.labelChamp.newCivilite')}}
        </h1>
        <MsgError
          v-if="isError"
          type="is-danger"
          :msg="msgError"
          @close="msgErrorClose"/>
        <b-field :type="valueInputIsError ? 'is-danger' : ''" expanded>
          <template slot="label">
            <p class="is-size-7 has-text-grid-2">
              {{$t('ajoutContact.labelChamp.civilite')}}
            </p>
          </template>
          <b-input v-model="civiliteAjouter.libelle"></b-input>
        </b-field>
      </div>
      <div class="has-text-centered mt-10">
        <b-button
          type="is-transparent"
          class="has-text-default"
          @click="$parent.close()">
          {{$t('general.btnAnnuler')}}
        </b-button>
        <b-button
          type="is-primary"
          class="has-text-weight-bold ml-20"
          @click="save">
          {{$t('general.btnAjouter')}}
        </b-button>
      </div>
    </div>
</template>

<script>
import { create as CreateCiviliteAsync } from '@/api/parametrage';
import MsgError from '@/components/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

export default {
  components: {
    MsgError,
  },
  props: {
    civiliteAjouter: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isError: false,
    msgError: '',
    valueInput: '',
    valueInputIsError: false,
  }),
  computed: {
  },
  methods: {
    showMsgError(msg) {
      this.msgError = msg;
      this.isError = true;
    },
    msgErrorClose() {
      this.valueInputIsError = false;
      this.isError = false;
    },
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      if (this.civiliteAjouter.libelle) {
        const res = await CreateCiviliteAsync(PARAMETRES_KEYS.civilite, this.civiliteAjouter);
        loadingComponent.close();
        this.$emit('save', res.data.result);
        this.$parent.close();
      } else {
        this.valueInputIsError = true;
        this.showMsgError(this.$t('general.msgErrorChampObligatoire'));
      }
    },
  },
};
</script>

<style>

</style>

